"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionTypeRequirementOptions = sessionTypeRequirementOptions;
/**
 * The workflow builders offer one requirement option per session type, plus an
 * "(Observations)" variant for types that allow observations. The variant is
 * fulfilled by observer-seat hours on observation drives; the plain option by
 * driving hours (including the driver seat on observation drives). The suffix
 * is display-only — the API stores the distinction as the requirement's
 * `observation` boolean.
 */
function sessionTypeRequirementOptions(sessionTypes) {
    var options = [];
    for (var _i = 0, sessionTypes_1 = sessionTypes; _i < sessionTypes_1.length; _i++) {
        var sessionType = sessionTypes_1[_i];
        options.push({
            id: sessionType.id,
            name: sessionType.name,
            label: sessionType.name,
            observation: false,
        });
        if (sessionType.allow_observations === true) {
            options.push({
                id: sessionType.id,
                name: sessionType.name,
                label: "".concat(sessionType.name, " (Observations)"),
                observation: true,
            });
        }
    }
    return options;
}
